import { track } from '@fff-web/fff-analytics';
import getSwapAmountByPlanCode from '../../../../utils/getSwapAmountByPlanCode';
import { REACTIVATE_MEMBERSHIP_LABEL } from '../../../constants';
import { MY_ACCOUNT_EXPERIENCE } from '../../utils/segment';

const CLICK_FOR_SWAP_EVENT_NAME = 'Swap Started';
const CLICK_FOR_SWAP_CTA_NAME = 'Swap for credit';
const CLICK_FOR_REACTIVATION_CTA_NAME = 'Reactivation Started';

const trackClickSwapForCredit = (planCode: string) => {
  const properties = {
    swap_amount: getSwapAmountByPlanCode(planCode),
    cta_name: CLICK_FOR_SWAP_CTA_NAME,
    experience: MY_ACCOUNT_EXPERIENCE,
  };
  track({ trackName: CLICK_FOR_SWAP_EVENT_NAME, properties }).finally(() => true);
};

const trackClickCancelSubscription = (eventName: string, ctaName: string, cancelType: string) => {
  const properties = {
    cta_name: ctaName,
    experience: MY_ACCOUNT_EXPERIENCE,
    cancel_type: cancelType,
  };
  track({ trackName: eventName, properties }).finally(() => true);
};

const trackClickReactivateMembership = () => {
  const properties = {
    cta_name: REACTIVATE_MEMBERSHIP_LABEL,
    type: 'Expired Member',
    experience: MY_ACCOUNT_EXPERIENCE,
    reactivation_type: 'Expired',
  };
  track({ trackName: CLICK_FOR_REACTIVATION_CTA_NAME, properties }).finally(() => true);
};

export { trackClickSwapForCredit, trackClickCancelSubscription, trackClickReactivateMembership };
